module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/core-js/array/from.js
// module id = 247
// module chunks = 0 1


// WEBPACK FOOTER //
// webpack:///node_modules/babel-runtime/core-js/array/from.js